import React from 'react'

export default function ErrorMessage(prop) {
    const message = prop.message;
    return (
        <>
            <div className={prop.class}>
                <span dangerouslySetInnerHTML={{ __html: message }} />
            </div>
        </>
    );
};
